import { AxiosRequestConfig } from 'axios';

import axios from '../../../axios';
import { DncDetailsDTO } from '../../../types';
import { IClientDTO } from '../../JobSearchService';
import { ClientContactShareDTO } from '../types/ClientContactShareDTO';
import { ClientContactShareMultipleDTO } from '../types/ClientContactShareMultipleDTO';
import { ClientShareDTO } from '../types/ClientShareDTO';
import { ClientShareMultipleDTO } from '../types/ClientShareMultipleDTO';

const url = '/api/clients';
const clientContactdncUrl = `/invoicingservice/api/client-contact`;

export const saveClient = (client: IClientDTO) => axios.post(`${url}`, client);
export const updateClient = (client: IClientDTO) => axios.put(`${url}`, client);

const clientSharingUrl = '/invoicingservice/api/client-sharing';

export const getClientAssignedUser = (clientId: string) =>
  axios.get(`${clientSharingUrl}/assigned/users?clientId=${clientId}`);

export const getAssignedUserForClientCount = () =>
  axios.get(`${clientSharingUrl}/assigned/users/count`);

export const getAssignedClient = (email: string, config?: AxiosRequestConfig) =>
  axios.get(`${clientSharingUrl}/assigned/client?email=${email}`, config);

export const revokeClientUser = (clientDTO: ClientShareDTO) =>
  axios.put(`${clientSharingUrl}/revoke`, clientDTO);

export const revokeAllAccess = (email: string) =>
  axios.get(`${clientSharingUrl}/revoke/all?email=${email}`);

export const assignClientUser = (clientDTO: ClientShareMultipleDTO) =>
  axios.post(`${clientSharingUrl}/grant`, clientDTO);

const clientContactSharingUrl = '/invoicingservice/api/client-contact-sharing';

export const getAssignedUserForClientContact = (clientDTO: ClientContactShareDTO) =>
  axios.post(`${clientContactSharingUrl}/assigned/users`, clientDTO);

export const revokeClientContact = (clientDTO: ClientContactShareDTO) =>
  axios.put(`${clientContactSharingUrl}/revoke`, clientDTO);

export const assignClientContact = (clientDTO: ClientContactShareMultipleDTO) =>
  axios.post(`${clientContactSharingUrl}/grant`, clientDTO);

export const getAssignedUserForClientContactCount = () =>
  axios.get(`${clientContactSharingUrl}/assigned/users/count`);

export const getAssignedClientContact = (email: string, config?: AxiosRequestConfig) =>
  axios.get(`${clientContactSharingUrl}/assigned/client?email=${email}`, config);

export const assignDncDetails = (dncId: string, dnctDTO: DncDetailsDTO) =>
  axios.put(`${clientContactdncUrl}/dnc-details/${dncId}`, dnctDTO);
